import styled from "styled-components"
export const GridOrderDetailWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  width: 100%;
  padding-bottom: 1rem;

  .column {
    display: flex;
    flex-direction: column;
    flex: 1;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  }
`

export const ProductsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;

  .products-title-banner {
    background: #451287;
    color: ${({ theme }) => theme.palette?.white || '#ffffff'};
    border: 1px solid #d5c3f0;
    padding: 0.5rem 1.25rem;
    border-radius: 10px 10px 0px 0px;
    font-size: 1.1rem;
    font-weight: 700;
    box-shadow: 0 2px 8px rgba(69, 18, 135, 0.05);
    display: flex;
    align-items: center;
    gap: 0.5rem;
    justify-content: center;
  }

  .products-sub-title-banner {
    color: ${({ theme }) => theme.palette?.primary || '#451287'};
    padding: 0rem 1.25rem;
    border-radius: 10px;
    font-size: 1.1rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const ProductsFlexWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1.25rem;
  width: 100%;

  & > div {
    flex: 0 0 calc(50% - 0.625rem);
    box-sizing: border-box;
  }

  @media (max-width: 768px) {
    & > div {
      flex: 0 0 100%;
    }
  }
`

export const ProductsFlexWrapperInfo = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  gap: 0.75rem 1.25rem;
  padding: 0.75rem;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);

  .detail-field {
    flex: 0 0 calc(50% - 0.625rem);
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    gap: 0.25rem;
    font-size: 1rem;
    color: #707590;

    .field-label {
      font-weight: 600;
      color: #3e405b;
    }

    .field-value {
      font-weight: 400;
    }
  }

  .row {
    display: flex;
    flex-direction: row;
    gap: 0.75rem;
    width: 100%;

    .col {
      display: flex;
      flex-direction: column;
      flex: 0 0 calc(50% - 0.625rem);
    }

    .title {
      font-size: 1rem;
      color: #3e405b;
      font-weight: bold;
      text-align: center;
    }

    .info {
      font-size: 1rem;
      color: #3e405b;
      text-align: center;
    }
  }

  @media (max-width: 768px) {
    .detail-field {
      flex: 0 0 100%;
    }

    .row {
      flex-direction: column;
    }
  }
`

export const ProductCardFlex = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.25rem;
  padding: 0.75rem;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border-left: 5px solid ${({ theme }) => theme.palette.primary || '#451287'};
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-sizing: border-box;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
  }

  .product-image-container {
    flex-shrink: 0;
    width: 80px;
    height: 80px;
    border-radius: 8px;
    overflow: hidden;
    background: #f5f6f8;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ecedf1;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;
    }
  }

  &:hover .product-image-container img {
    transform: scale(1.08);
  }

  .product-info-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    flex-grow: 1;

    .product-name-title {
      font-size: 1.05rem;
      font-weight: bold;
      color: #3e405b;
      margin: 0;
    }

    .product-details-grid {
      display: flex;
      flex-direction: column;
      gap: 0.35rem;
      width: 100%;

      .detail-field {
        display: flex;
        flex-direction: row;
        gap: 0.25rem;
        font-size: 1rem;
        color: #707590;

        .field-label {
          font-weight: 600;
          color: #3e405b;
        }

        .field-value {
          font-weight: 400;
        }
      }
    }
  }

  @media (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;

    .product-image-container {
      width: 100%;
      height: 140px;
    }
  }
`
export const ProductsWrapperContainer = styled.div`
  display: flex;
  padding: 1rem;
  background: #ffffff;
  flex-direction: column;
  border-radius: 0px 0px 10px 10px;

  .row {
    display: flex;
    flex-direction: row;
    gap: 0.75rem;
    width: 100%;
  }

  .item {
    padding: 0.5rem 0;
    border-bottom: 1px solid #ddd;

    &:last-child {
      border-bottom: none;
    }
  }
`

export const ProductRow = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  padding: 0.5rem 0;
  border-bottom: 1px solid #ddd;

  &.no-border {
    border-bottom: none;
  }

  &:last-child {
    border-bottom: none;
  }

  .field-row {
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 0.75rem;
    align-items: center;

    .field-label,
    .field-value {
      flex: 1;
      font-size: 1rem;
    }

    .field-label {
      color: #3e405b;
      font-weight: 600;
    }

    .field-value {
      color: #707590;
      font-weight: 400;
    }

    .text-right {
      text-align: right;
    }
  }
`
